export default function (PdfViewerBase) {
	// Prevent annotations from being deleted with the delete key
	PdfViewerBase.DeleteKeyPressed = new Function();
}